const getValueByPath = (context, path) =>
  String(path)
    .split(".")
    .reduce(
      (value, property) =>
        value !== null && value !== undefined ? value[property] : undefined,
      context
    );

const decodeHtmlEntities = (text) => {
  const entities = {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    nbsp: " ",
    quot: '"',
  };

  return text.replace(
    /&(#(?:x[0-9a-f]+|\d+)|amp|apos|gt|lt|nbsp|quot);/gi,
    (entity, code) => {
      if (code.charAt(0) !== "#") return entities[code.toLowerCase()] || entity;

      const hexadecimal = code.charAt(1).toLowerCase() === "x";
      const codePoint = parseInt(
        code.slice(hexadecimal ? 2 : 1),
        hexadecimal ? 16 : 10
      );
      return Number.isNaN(codePoint)
        ? entity
        : String.fromCodePoint(codePoint);
    }
  );
};

export const sanitizeExcelText = (value) => {
  if (value === undefined || value === null) return "";

  const text = decodeHtmlEntities(
    String(value)
      .replace(/<\s*br\s*\/?\s*>/gi, "\n")
      .replace(/<\s*li(?:\s[^>]*)?>/gi, "• ")
      .replace(
        /<\s*\/\s*(?:p|div|h[1-6]|li|tr|section|article)\s*>/gi,
        "\n"
      )
      .replace(/<[^>]*>/g, "")
  )
    .replace(/\r\n?/g, "\n")
    .replace(/[ \t]+\n/g, "\n")
    .replace(/\n{3,}/g, "\n\n")
    .trim();

  return Array.from(text)
    .filter((character) => {
      const codePoint = character.codePointAt(0);
      return (
        codePoint === 0x09 ||
        codePoint === 0x0a ||
        codePoint === 0x0d ||
        (codePoint >= 0x20 && codePoint <= 0xd7ff) ||
        (codePoint >= 0xe000 && codePoint <= 0xfffd) ||
        (codePoint >= 0x10000 && codePoint <= 0x10ffff)
      );
    })
    .join("")
    .trim();
};

export const formatWhatsAppMessage = (message, variables, context) => {
  if (!message) return "";

  const availableVariables = {
    ...(variables || {}),
    mother_id: "mother.id",
  };

  const formattedMessage = Object.keys(availableVariables).reduce(
    (currentMessage, key) => {
      const value = getValueByPath(context, availableVariables[key]);
      if (value === undefined || value === null) return currentMessage;

      const placeholders = [
        `{{${key}}}`,
        `%7B%7B${key}%7D%7D`,
        `%7b%7b${key}%7d%7d`,
      ];

      return placeholders.reduce(
        (text, placeholder) => text.split(placeholder).join(String(value)),
        currentMessage
      );
    },
    message
  );

  return sanitizeExcelText(formattedMessage);
};